/* eslint-disable react/no-array-index-key */
import { FC } from 'react';

import Heading from 'molecules/Heading';
import Section from 'molecules/Section';
import { splitSectionProps } from 'molecules/Section/config';

import ResourceCard from 'organisms/Cards/Resource';

import ScrollFadeSection from 'components/Animations/ScrollFadeSection';
import { ResourceCardDeckConfigProps } from 'components/CardDeck/Resource/config';
import { CardStyle } from 'components/CardDeck/Resource/styles';

import { hasArrayValues } from 'utils/array/arrays';

const ResourceCardDeck: FC<ResourceCardDeckConfigProps> = props => {
  const { sectionProps, rest } = splitSectionProps(props);
  const { eyebrow, heading, body, buttons, resources, isDarkMode } = rest;
  const isDark = Boolean(isDarkMode);
  const filteredResources = resources?.filter(resource => resource?.resource?.value?.data);
  const isFullCards = filteredResources?.length === 3;

  return (
    <Section darkMode={isDark} noDarkMode={!isDark} id={sectionProps.id || 'resourcesHidden'}>
      <div className="flex w-full flex-col items-center justify-center gap-8 sm:gap-12 lg:gap-16">
        <Heading eyebrow={eyebrow} heading={heading} body={body} buttons={buttons} alignment="center" />
        <ScrollFadeSection delay={0.2}>
          <div className="flex w-full flex-row flex-wrap justify-center gap-8">
            {hasArrayValues(filteredResources) &&
              filteredResources?.map((resource, idx) => (
                <div key={idx} className={CardStyle({ isFullCards })}>
                  <ResourceCard {...resource?.resource?.value?.data} isDark={isDark} />
                </div>
              ))}
          </div>
        </ScrollFadeSection>
      </div>
    </Section>
  );
};

export default ResourceCardDeck;
